<template>
  <div class="scenicSpotsWeather">
    <div class="publishTime">{{ publishTime }}</div>
    <el-carousel
      trigger="click"
      indicator-position="none"
      :autoplay="false"
      arrow="always"
    >
      <el-carousel-item v-for="(item, index) in dataArray" :key="index">
        <div
          class="itemContainer"
          v-for="(spotItem, spotIndex) in item"
          :key="spotIndex"
        >
          <div class="left">
            <img
              v-if="spotItem.imgUrl"
              :src="require('../../assets/images/travel/' + spotItem.imgUrl)"
              alt=""
            />
            <div class="spotName">{{ spotItem.spotName }}</div>
          </div>
          <div class="right">
            <div class="text">{{ spotItem.weather }}</div>
            <div class="text">{{ spotItem.temperature }}</div>
            <div class="text">{{ spotItem.windDirection }}</div>
            <div class="text">{{ spotItem.windLevel }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { home } from '../../api/index'
export default {
  created () {
    var address = {
      广州白水寨风景名胜区: [113.770364, 23.586481, 170, 310, 'AAAA', 'G3248'],
      广州宝墨园: [113.301952, 22.942228, 390, 135, 'AAAA', 'G1092'],
      广州碧水湾温泉度假村: [113.722348, 23.705889, 115, 280, 'AAAA', 'G1085'],
      广州陈家祠旅游区: [113.253119, 23.132053, 470, 370, 'AAAA', 'G1045'],
      广州动物园: [113.311697, 23.147651, 455, 385, 'AAAA', 'G1053'],
      广东科学中心: [113.369494, 23.045298, 360, 165, 'AAAA', 'G3220'],
      广州广东美术馆: [113.314123, 23.11422, 475, 460, 'AAAA', 'G3221'],
      广州华南植物园: [113.374057, 23.18775, 370, 520, 'AAAA', 'G1036'],
      广州黄花岗七十二烈士墓园: [113.302673, 23.144648, 465, 415, 'AAAA', 'G1053'],
      广州九龙湖度假区: [113.426103, 23.466746, 200, 170, 'AAAA', 'G3418'],
      广州莲花山旅游区: [113.51031, 22.990085, 375, 200, 'AAAA', 'G3244'],
      广州烈士陵园: [113.292293, 23.132839, 460, 410, 'AAAA', 'G1053'],
      广州岭南印象园: [113.391439, 23.043941, 360, 175, 'AAAA', 'G3125'],
      广州南沙湿地游览区: [113.64552, 22.616203, 510, 250, 'AAAA', 'G1017'],
      广州石头记矿物园: [113.16726, 23.406659, 225, 100, 'AAAA', 'G1081'],
      广州西汉南越王墓博物馆: [113.320715, 23.155404, 440, 410, 'AAAA', 'G1053'],
      广州越秀公园: [113.272172, 23.146636, 440, 390, 'AAAA', 'G1053'],
      广州正佳广场: [113.333655, 23.138651, 455, 480, 'AAAA', 'G3221'],
      广州长隆旅游度假区: [113.340787, 23.011491, 370, 155, 'AAAAA', 'G1000'],
      广州白云山风景区: [113.306031, 23.18619, 300, 138, 'AAAAA', 'G3407'],
      广州中山纪念堂: [113.271142, 23.139723, 450, 395, 'AAAA', 'G1053'],
      广州南海神庙: [113.504013, 23.087577, 340, 205, 'AAAA', 'G3329']
    }
    const windCont = ['北风', '东北风', '东风', '东南风', '南风', '西南风', '西风', '西北风', '北风']
    home.getGZ_travelIntroduce().then(async data => {
      for (const item in data) {
        for (const addressItem in address) {
          if (item === addressItem) {
            var lon = Math.floor(address[item][0] / 0.05) * 0.05
            var lat = Math.floor(address[item][1] / 0.05) * 0.05
            var name = ('giftDaily' + lon.toFixed(2) + '_' + lat.toFixed(2)).replace(/\./g, '')
            const res = await home.getGZ_scenicSpotsWeather(name)
            const tempObj = {
              spotName: item,
              imgUrl: data[item].imgUrl,
              weather: res.desc_f[0],
              temperature: res.mint[0] + '℃-' + res.maxt[0] + '℃',
              windDirection: '风向: ' + windCont[parseInt((res.hour24_windd[23] + 22.5) / 45)],
              windLevel: '风力: ' + res.hour24_winds[23] + 'm/s'
            }
            this.dataArray.push(tempObj)
          }
        }
      }
      let tempArray = []

      // 封装成两个两个一组
      for (let i = 0; i < this.dataArray.length; i += 2) {
        const itemArray = []
        itemArray.push(this.dataArray[i])
        itemArray.push(this.dataArray[i + 1])
        tempArray.push(itemArray)
      }
      this.dataArray = tempArray
      tempArray = null
      // console.log(this.dataArray);
    })

    const date = new Date()
    date.setHours(8)
    date.setMinutes(0)
    date.setSeconds(0)
    this.publishTime = date.format('yyyy-MM-dd hh:mm:ss 发布')
  },
  data () {
    return {
      // 封装数据结构
      dataArray: [],

      // 发布时间
      publishTime: ''
    }
  }
}
</script>

<style lang="less" scoped>
.scenicSpotsWeather {
  position: relative;
  .publishTime {
    position: absolute;
    right: 5px;
    top: -43px;
    color: white;
    font-size: 12px;
  }
  .el-carousel__container {
    height: 254px;
  }
  .itemContainer {
    display: flex;
    justify-content: space-evenly;
    color: #333;
    font-size: 14px;
    height: 127px;
    padding-bottom: 20px;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 130px;
        height: 87px;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
    }
  }
}
</style>
